// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__Iv4Mh","container":"Loader_container__C6ygW","box":"Loader_box__Tb34I","jump_4123":"Loader_jump_4123__6r5HH","description":"Loader_description__P5MPt"};